import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiChevronLeft = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z" />
  </SvgWrapper>
);
